export const cs_qrcode = 'http://duy-ielts-public.oss-cn-hangzhou.aliyuncs.com/front/cs_qrcode.png';
